var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 17.72H3.94a.66.66 0 0 1-.66-.66V13.4a.65.65 0 0 1 .19-.46l9.84-9.85a.66.66 0 0 1 .94 0l3.66 3.66a.66.66 0 0 1 0 .94l-9.85 9.84a.65.65 0 0 1-.46.19v0ZM11.16 5.25l4.59 4.6",
    stroke: "grey",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/edit-grey.312e6ba7e92ca18918afbc28d603d302.svg";
export { ForwardRef as ReactComponent };